module.exports = __webpack_public_path__ + "static/media/grid-inactive.37097b3b.svg";